import { useState } from "react";
import styled, { css } from "styled-components";

import AtomLogo from "Components/Atoms/Logo";
import AtomNowLogo from "Components/Atoms/NowLogo";
import MoleculeSearch from "Components/Molecules/Search";

import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   position: relative;
   width: 100%;
   height: 97px;
   ${({ css }) => css}
`;
const LogoWrap = styled.div`
   display: flex;
   position: absolute;
   width: 100%;
   left: 0px;
   top: 0px;
   height: 100%;
   justify-content: flex-start;
   align-items: center;
`;
const NowLogoWrap = styled.div`
   display: flex;
   position: absolute;
   width: 100%;
   left: 0px;
   top: 0px;
   height: 100%;
   justify-content: center;
   align-items: center;
`;
const SearchWrap = styled.div`
   display: flex;
   position: absolute;
   width: 100%;
   left: 0px;
   top: 0px;
   height: 100%;
   justify-content: flex-end;
   align-items: center;
`;

export default function Header(props: Types.Default) {
   const [searchValue, setSearchValue] = useState("");

   function searchOnChange(ev: any) {
      console.log("set value", ev.target.value);
      setSearchValue(ev.target.value);
   }

   function searchOnKeyDown(ev: any) {
      console.log("key down ev", ev);
      if (ev.key === "Enter") {
         window.location.href = "https://art-map.co.kr/search/list.php?keyword=" + encodeURIComponent(searchValue);
      }
   }

   return (
      <Wrap css={props.css}>
         <LogoWrap>
            <AtomLogo
               css={css`
                  z-index: 100;
               `}></AtomLogo>
         </LogoWrap>

         <NowLogoWrap>
            <AtomNowLogo
               css={css`
                  z-index: 100;
               `}></AtomNowLogo>
         </NowLogoWrap>

         <SearchWrap>
            <MoleculeSearch onKeyDown={searchOnKeyDown} onChange={searchOnChange} value={searchValue}></MoleculeSearch>
         </SearchWrap>
      </Wrap>
   );
}
